<template>
  <div class="billManagement" style="padding-left:10px">
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/billManagement' }">返回上一级</el-breadcrumb-item>
      <el-breadcrumb-item>
        {{title}}
      </el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 查询条件 -->
    <el-form :inline="true" :model="formData" :rules="rules" class="demo-form-inline" ref="formData">
      <el-form-item label="结算客户:" prop="customerName">
        <el-select v-model="formData.customerName" size="mini" placeholder="请选择" filterable clearable
          style="width:230px" @change="customerChange" :disabled='disabledcustomer'>
          <el-option v-for="(item,index) in keHuOptions" :key="index" :label="item.showName" :value="item.showName">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="账单备注:" prop="zhangdanRemark">
        <el-input v-model="formData.zhangdanRemark" placeholder="请输入" size="mini" maxlength="50"
          style="width:135px;vertical-align:top;"></el-input>
      </el-form-item>
      <hr>
      <el-form-item label="费用合计:" prop="cangchufei">
        <span style="color:red;">{{formData.cangchufei}}</span>元
      </el-form-item>
      <el-form-item label="附加:" prop="fujiafei">
        <el-input v-model="formData.fujiafei" v-number-input.float="2" @blur="fujiafeiInput" placeholder="请输入"
          size="mini" style="width:135px;vertical-align:top;"><span slot="suffix">元</span></el-input>
      </el-form-item>
      <el-form-item label="减免:" prop="koujianfei">
        <el-input v-model="formData.koujianfei" v-number-input.float="2" @blur="koujianInput" placeholder="请输入"
          size="mini" style="width:150px;vertical-align:top;"><span slot="suffix">元</span></el-input>
      </el-form-item>
      <el-form-item label="应收:" prop="heji">
        <span style="color:red;">{{formData.heji}}</span>元
      </el-form-item>
      <el-form-item label="费用备注:" prop="feiyongbeizhu">
        <el-input v-model="formData.feiyongbeizhu" placeholder="请输入" size="mini"
          style="width:210px;vertical-align:top;"></el-input>
      </el-form-item>
    </el-form>
    <hr>
    <div style="margin-bottom:10px">费用明细：
      <el-button type="primary" size="mini" @click="tianjia" v-if="btnFlg[23]" btnCode="003M320P00">新增</el-button>
      <el-button type="primary" size="mini" @click="shanchu" v-if="btnFlg[24]" btnCode="003M320Q00">删除</el-button>
      <span style="margin-left:10px">费用合计：<span style="color:red;">{{formData.cangchufei}}</span> 元</span>
      <!-- <span style="margin-left:10px">总件数：<span style="color:red;">{{allNumber}}</span> 件,&nbsp;&nbsp;总吨数：<span style="color:red;">{{allWeight}}</span> 吨</span> -->
    </div>
    <div :style="{ height: '405px' }" v-if="this.tableData.length == 0" class="tablestyle">
      <span style="color:#9a9ca2">暂无数据</span>
    </div>
    <div :style="{ height: '405px' }" v-else>
      <el-table height="100%" size="mini" border center bordersize="mini" ref="tabref1" :data="tableData"
        style="width: 100%" class="elTab" :header-cell-style="{ background: '#F5F5F5', color: 'black' }"
        highlight-current-row @selection-change="selectGoods">
        <el-table-column type="selection" align="center" width="60"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="productTypeName" label="货物类型" align="center" width="100">
        </el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="steelMillName" label="产地" align="center" width="100">
        </el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="specification" label="规格" align="center" width="100">
        </el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="model" label="材质" align="center" width="100">
        </el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="number" label="件数" align="center" width="100">
        </el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="weight" label="总重量(吨)" align="center" width="120">
        </el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="feeType" label="费用类型" align="center" width="100">
          <!-- <template v-slot="scope">
            {{['入库费','仓储费','转货费','出库费'][scope.row.feeType-1]}}
          </template> -->
        </el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="unitPrice" label="单价" align="center" width="100">
        </el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="feeAmount" label="金额" align="center" width="100">
        </el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="customerName" label="二级货主" align="center" width="250">
        </el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="primaryCustomerName" label="一级货主" align="center"
          width="250"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="plateNumber" label="车牌号" align="center" width="120">
        </el-table-column>
        <div v-if="chaoqiFlag==1">
          <el-table-column :show-overflow-tooltip="true" prop="instockDate" label="入库日期" align="center" width="120">
          </el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="outstockDate" label="出库日期" align="center" width="120">
          </el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="stockDate" label="库存天数" align="center" width="80">
          </el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="overdueDate" label="超期天数" align="center" width="80">
          </el-table-column>
        </div>
        <el-table-column :show-overflow-tooltip="true" prop="businessType" label="业务类型" align="center" width="120">
        </el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="businessNo" label="业务单号" align="center" width="250">
        </el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="businessTime" label="业务时间" align="center" width="100">
        </el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="inRansportMethod" label="到货方式" align="center" width="100">
        </el-table-column>
      </el-table>
    </div>
    <div style="width:100px;margin:5px auto">
      <el-button type="primary" size="mini" @click="queding">提交</el-button>
    </div>
    <!-- dialog -->
    <!--点击添加-->
    <add-dialog-jc v-if="addVisible" :addVisible.sync='addVisible' :delfeeDetailJcIdList="delfeeDetailJcIdList"
      @gettables='getSelectedTable' :customerName="customerName"></add-dialog-jc>
    <!--点击查看凭证-->
    <div class="addMarkBox">
      <el-dialog title="查看图片" :close-on-click-modal="false" :visible.sync="addMarkLookBox" width="60%" center>
        <!-- <div v-if="!imgFlag">
            <div>无货损图片</div>
          </div>-->
        <div class="img_box">
          <div v-for="(item, index) in imgData" :key="index">
            <img :src="item.url" alt />
            <!-- <i v-if="seen" class="el-icon-delete" @click="delImg(item)"></i> -->
            <i class="el-icon-zoom-in" @click="handChange(item.url)"></i>
          </div>
        </div>
        <el-dialog class="oneTwo" :visible.sync="dialogVisible" title="查看凭证" append-to-body width="40%" center
          :close-on-click-modal="false">
          <div class="imgDialog">
            <img :src="imageD" alt />
          </div>
        </el-dialog>
        <div style="width: 158px; margin: 15px auto"></div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
  import addDialogJc from './addDialogJc.vue'
  import {
    addJCFee,
    getDictionaryJson,
    getJCFeeList
  } from '@/api/wms-stock'
  import {
    getQueryCusterData // 客户
  } from '@/api/platform-settlement'
  import DonMessage from '@/utils/message'
  import {
    getCargoDamagePicture // 查看图片
  } from '@/api/wms-access'
  import {
    getBtn
  } from '@/utils/getButton'

  export default {
    components: {
      addDialogJc
    },
    name: 'billManagement',
    data() {
      return {
        formData: {
          customerName: '',
          zhangdanRemark: '',
          cangchufei: 0,
          fujiafei: '',
          koujianfei: '',
          heji: 0,
          feiyongbeizhu: ''
        },
        h: '200px',
        keHuOptions: [],
        tableData: [],
        addVisible: false,
        chaoqiFlag: 0,
        rules: {
          customerName: [{
            required: true,
            message: '请选择',
            trigger: 'change'
          }],
          zhangdanRemark: [{
            required: false,
            message: '请选择',
            trigger: 'change'
          }],
          // cangchufei: [{ required: true, message: '请选择', trigger: 'change' }],
          fujiafei: [{
            required: false,
            message: '请选择',
            trigger: 'change'
          }],
          koujianfei: [{
            required: false,
            message: '请选择',
            trigger: 'change'
          }],
          heji: [{
            required: false,
            message: '请选择',
            trigger: 'change'
          }],
          feiyongbeizhu: [{
            required: false,
            message: '请选择',
            trigger: 'change'
          }]
        },
        selectedTable: [],
        addMarkLookBox: false,
        imageD: '',
        dialogVisible: false,
        imgData: [],
        title: '',
        customerName: '',
        btnFlg: [],
        btnFlg: [],
        btnIdArr: [
          '003M320200',
          '003M320300',
          '003M320400',
          '003M320500',
          '003M320600',
          '003M320700',
          '003M320800',
          '003M320900',
          '003M320A00',
          '003M320B00',
          '003M320C00',
          '003M320D00',
          '003M320E00',
          '003M320F00',
          '003M320G00',
          '003M320H00',
          '003M320I00',
          '003M320J00',
          '003M320K00',
          '003M320L00',
          '003M320M00',
          '003M320N00',
          '003M320O00',
          '003M320P00',
          '003M320Q00',
          '003M320R00',
          '003M320S00',
          '003M320T00',
          '003M320U00',
          '003M320V00'

        ],
        titleList: [],
        allNumber: 0,
        allWeight: 0,
        disabledcustomer: false,
        delfeeDetailJcIdList: ''
      }
    },
    methods: {
      customerChange() {
        this.tableData = []
        this.allNumber = 0
        this.allWeight = 0
        this.formData.cangchufei = 0
        this.formData.heji = 0
        this.formData.fujiafei = ''
        this.formData.zhangdanRemark = ''
        this.formData.koujianfei = ''
        this.formData.feiyongbeizhu = ''
      },
      // 查看凭证-放大
      handChange(url) {
        this.imageD = url
        this.dialogVisible = true
      },
      // 图片查看
      imgShow(row) {
        this.addMarkLookBox = true
        getCargoDamagePicture({
            cargoId: row.cargoId // 货物id
          })
          .then((res) => {
            this.imgData = []
            this.imgData = res
          })
          .catch((err) => {
            DonMessage.error(err.message)
          })
      },
      selectGoods(selection) {
        this.selectedTable = selection
      },
      fujiafeiInput() {
        this.formData.heji = (this.formData.cangchufei / 1 + this.formData.fujiafei / 1 - this.formData.koujianfei / 1)
          .toFixed(2)
      },
      koujianInput() {
        this.formData.heji = (this.formData.cangchufei / 1 + this.formData.fujiafei / 1 - this.formData.koujianfei / 1)
          .toFixed(2)
      },
      tianjia() {
        if (!this.formData.customerName) {
          this.$message({
            message: '请先选择客户',
            type: 'error'
          })
          return
        }
        this.delfeeDetailJcIdList = this.tableData.map(item => item.feeDetailJcId).join(',')
        this.addVisible = true
        this.customerName = this.formData.customerName
      },
      shanchu() {
        let feeDetailJcId = Array.from(new Set(this.selectedTable.map(item => item.feeDetailJcId)))
        for (let i = 0; i < feeDetailJcId.length; i++) {
          this.tableData = this.tableData.filter(item => item.feeDetailJcId != feeDetailJcId[i])
        }
        this.formData.cangchufei = this.tableData.reduce((cur, pre) => {
          return cur + pre.feeAmount / 1
        }, 0).toFixed(2)
        this.$set(this.formData, 'heji', (this.formData.cangchufei / 1 + this.formData.fujiafei / 1 - this.formData
          .koujianfei / 1).toFixed(2))
        // this.formData.heji = (this.formData.cangchufei / 1 + this.formData.fujiafei / 1 - t/his.formData.koujianfei / 1).toFixed(2)
        console.log(this.formData.heji)
        this.allNumber = this.tableData.length
        this.allWeight = this.tableData.reduce((pre, cur) => (pre / 1 + cur.weight / 1).toFixed(3), 0)
      },
      queding() {
        this.$refs.formData.validate(valid => {
          if (valid) {
            if (this.formData.koujianfei * 1 > this.formData.cangchufei * 1) {
              this.$message.error('减免费用不得大于费用合计')
              return
            }
            let paycustomername = this.keHuOptions.filter(item => item.showName == this.formData.customerName)[0]
              .itemNo
            const ids = this.tableData.map(item => item.feeDetailJcId).join(',')
            addJCFee({
                payCustomerNameTaxId: paycustomername,
                payCustomerName: this.formData.customerName,
                remark: this.formData.zhangdanRemark,
                totalFee: this.formData.cangchufei,
                additionalFee: this.formData.fujiafei,
                deductionFee: this.formData.koujianfei,
                receivableFee: this.formData.heji,
                feeRemark: this.formData.feiyongbeizhu,
                feeDetailJcIdList: ids,
                feeMasterId: this.formData.feeMasterId ? this.formData.feeMasterId : ''
              })
              .then(res => {
                console.log(res)
                this.$message({
                  message: '添加成功',
                  type: 'success'
                })
                this.$router.push('/billManagement')
              })
              .catch(err => {
                this.$message({
                  message: err.message,
                  type: 'error'
                })
              })
          }
        })
      },
      // getTitleTable (val) {
      //   console.log(val)
      //   this.titleList = val
      // },
      getSelectedTable(val) {
        console.log(val)
        let paycustomername = this.keHuOptions.filter(item => item.showName == this.formData.customerName)[0].itemNo
        let feeDetailJcIds = Array.from(new Set(val.map(item => item.feeDetailJcId))).join(',')
        getJCFeeList({
            feeMasterId: -1,
            paycustomerNameTaxId: paycustomername,
            feeDetailJcIds
          }).then(res => {
            console.log(res)
            let arr = this.tableData.concat(val)

            const ress = new Map()
            let arrNew = arr.filter((arr) => !ress.has(arr.feeDetailJcId) && ress.set(arr.feeDetailJcId, 1))
            console.log(arrNew)
            this.tableData = arrNew
            this.formData.cangchufei = this.tableData.reduce((cur, pre) => {
              return cur + pre.feeAmount / 1
            }, 0).toFixed(2)
            this.formData.heji = (this.formData.cangchufei / 1 + this.formData.fujiafei / 1 - this.formData
              .koujianfei / 1).toFixed(2)
            console.log(this.formData.heji)
            this.allNumber = this.tableData.length
            this.allWeight = this.tableData.reduce((pre, cur) => (pre / 1 + cur.weight / 1).toFixed(3), 0)
          })
          .catch(error => {
            this.message.error(error.message)
          })
      },
      // 获取所属客户数据
      getQueryCusterData() {
        getQueryCusterData().then(res => {
          this.keHuOptions = res
        }).catch(err => {
          this.$message({
            message: err.message,
            type: 'error'
          })
        })
      }
    },
    mounted() {
      this.getQueryCusterData()
      this.btnFlg = getBtn(this.btnIdArr, '/billManagement')
      getDictionaryJson({
          groupNo: "jc_overdue_settlement_flag",
          itemNo: localStorage.getItem('tenantCode')
        })
        .then(res => {
          // 是否配置超期费，配置了则不显示预转+清单
          if (res.length !== 0) {
            this.chaoqiFlag = 1
          } else {
            this.chaoqiFlag = 0

          }
        })
        .catch(err => {
          this.$message({
            message: err.message,
            type: 'error'
          })
        })
      console.log(this.$route)
      if (JSON.stringify(this.$route.query) !== '{}') {
        this.disabledcustomer = true
        this.title = '修改结算'
        this.formData.customerName = this.$route.query.payCustomerName
        this.formData.customerTaxId = this.$route.query.payCustomerNameTaxId
        this.formData.zhangdanRemark = this.$route.query.remark
        this.formData.cangchufei = this.$route.query.storageFee
        this.formData.fujiafei = this.$route.query.additionalFee
        this.formData.koujianfei = this.$route.query.deductionFee
        this.formData.heji = this.$route.query.YStotalFee
        this.formData.feiyongbeizhu = this.$route.query.feeRemark
        this.formData.feeMasterId = this.$route.query.feeMasterId
        getJCFeeList({
            feeMasterId: this.$route.query.feeMasterId
          })
          .then(res => {
            console.log(res)
            this.tableData = res
            // this.total = res.total
            this.allNumber = res.length
            this.allWeight = res.reduce((pre, cur) => (pre / 1 + cur.weight / 1).toFixed(3), 0)
          })
          .catch(error => {
            this.$message({
              message: error.message,
              type: 'error'
            })
          })
      } else {
        this.title = '添加结算'
      }
    }
  }

</script>

<style lang="less" scoped>
  .el-form--inline .el-form-item {
    margin: 15px;
  }

  .tablestyle {
    border-top: 1px solid #dcdfe6;
  }

  /deep/ .el-form-item {
    margin: 10px;
  }

</style>
